import React from "react";
import "./Button.css";

interface ButtonProps {
  label: string;
  variant?: "primary" | "secondary";
  onClick?: () => void;
}

const AppButton: React.FC<ButtonProps> = ({
  label,
  variant = "primary",
  onClick,
}) => {
  return (
    <button className={`appbutton ${variant}`} onClick={onClick}>
      {label}
    </button>
  );
};

export default AppButton;
